import { render, staticRenderFns } from "./PreorderKWModal.vue?vue&type=template&id=5c4307bf&"
import script from "./PreorderKWModal.vue?vue&type=script&lang=js&"
export * from "./PreorderKWModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports